import { render, staticRenderFns } from "./ReportBoxTrendSales.vue?vue&type=template&id=4fb12d73&"
import script from "./ReportBoxTrendSales.vue?vue&type=script&lang=js&"
export * from "./ReportBoxTrendSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fb12d73')) {
      api.createRecord('4fb12d73', component.options)
    } else {
      api.reload('4fb12d73', component.options)
    }
    module.hot.accept("./ReportBoxTrendSales.vue?vue&type=template&id=4fb12d73&", function () {
      api.rerender('4fb12d73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity-flash/reports/ReportBoxTrendSales.vue"
export default component.exports